import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { ResidentialPropertyDetailComponent } from './report-property-detail/residential-property/residential-property-detail.component';
import { ReportPropertyInfoComponent } from './report-property-detail/components/report-property-info/report-property-info.component';
import { BuildUpInfoComponent } from './report-property-detail/components/build-up-info/build-up-info.component';
import { ReportsPreviewModule } from '../../../reports-preview/reports-preview.module';
import { I18nModule } from 'src/app/i18n/i18n.module';
import { CostOfConstructionComponent } from './report-property-detail/components/cost-of-construction/cost-of-construction.component';
import { PropertyAmenitiesComponent } from './report-property-detail/components/property-amenities/property-amenities.component';
import { UnitTransactionComponent } from './report-property-detail/components/unit-transaction/unit-transaction.component';
import { PropertyTransactionComponent } from './report-property-detail/components/property-transaction/property-transaction.component';
import { ResidentialRentalincomeAssessementComponent } from './report-property-detail/components/residential-rentalincome-assessement/residential-rentalincome-assessement.component';
import { LandValueDetailsComponent } from './report-property-detail/components/land-value-details/land-value-details.component';
import { SharedModule } from 'src/app/common/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OfficePropertyDetailComponent } from './report-property-detail/office-property-detail/office-property-detail.component';
import { RetailPropertyDetailComponent } from './report-property-detail/retail-property-detail/retail-property-detail.component';
import { UnitRentalComponent } from './report-property-detail/components/unit-rental/unit-rental.component';
import { OfficeUnitRentalComponent } from './report-property-detail/components/office-unit-transaction/office-unit-rental.component';
import { HousevillaPropertyDetailComponent } from './report-property-detail/housevilla-property-detail/housevilla-property-detail.component';
import { RentUnitSizeWiseComponent } from './report-property-detail/components/rent-unit-size-wise/rent-unit-size-wise.component';
import { WarehousePropertyDetailComponent } from './report-property-detail/warehouse-property-detail/warehouse-property-detail.component';
import { CommercialRentalIncomeAssessmentComponent } from './report-property-detail/components/commercial-rental-income-assessment/commercial-rental-income-assessment.component';
import { NearbyRentalsAndOccupancyComponent } from './report-property-detail/components/nearby-rentals-and-occupancy/nearby-rentals-and-occupancy.component';
import { WarehouseOverviewCardComponent } from './warehouse-overview-card/warehouse-overview-card.component';
import { WarehouseOverviewRentalYieldComponent } from './warehouse-overview-rental-yield/warehouse-overview-rental-yield.component';

@NgModule({
  declarations: [
    ResidentialPropertyDetailComponent,
    ReportPropertyInfoComponent,
    BuildUpInfoComponent,
    CostOfConstructionComponent,
    PropertyAmenitiesComponent,
    UnitTransactionComponent,
    PropertyTransactionComponent,
    ResidentialRentalincomeAssessementComponent,
    LandValueDetailsComponent,
    OfficePropertyDetailComponent,
    RetailPropertyDetailComponent,
    OfficeUnitRentalComponent,
    UnitRentalComponent,
    HousevillaPropertyDetailComponent,
    RentUnitSizeWiseComponent,
    WarehousePropertyDetailComponent,
    CommercialRentalIncomeAssessmentComponent,
    NearbyRentalsAndOccupancyComponent,
    WarehouseOverviewCardComponent,
    WarehouseOverviewRentalYieldComponent
  ],
  imports: [
    CommonModule,
    ReportsPreviewModule,
    I18nModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports:[
    ResidentialPropertyDetailComponent,
    ReportPropertyInfoComponent,
    BuildUpInfoComponent,
    CostOfConstructionComponent,
    OfficePropertyDetailComponent,
    RetailPropertyDetailComponent,
    OfficeUnitRentalComponent,
    HousevillaPropertyDetailComponent,
    WarehousePropertyDetailComponent,
    WarehouseOverviewCardComponent,
    WarehouseOverviewRentalYieldComponent
  ]
})
export class ReportCommonInfoModule { }
